export default __webpack_public_path__ + "static/media/PointEnd.214b928e.svg";